<script lang="ts" setup>
import { toRefs } from 'vue';

type Props = {
  src: string;
  width: number;
  height: number;
  level: number;
  alt?: string;
};

type Emits = {
  (e: 'on-image-loaded'): void;
};

const props = defineProps<Props>();
const emit = defineEmits<Emits>();
const { src, width, height } = toRefs(props);
</script>

<template>
  <div class="stack-container" :style="`width: ${width}px; height: ${height}px`">
    <v-img class="stack one elevation-4 rounded-sm" :src="src" :width="width" :height="height" :alt="alt" eager>
      <template #error>
        <slot name="error"></slot>
      </template>
    </v-img>
    <v-img
      v-if="level > 0"
      class="stack two elevation-4 rounded-sm"
      :src="src"
      :width="width"
      :height="height"
      :alt="alt"
      eager
      @load="emit('on-image-loaded')"
    >
      <template #error>
        <slot name="error"></slot>
      </template>
    </v-img>
  </div>
</template>

<style scoped lang="scss">
.stack-container {
  position: relative;
  overflow: visible;
}

.stack {
  position: absolute;
}

.one {
  top: 0px;
  z-index: -1;
  transform: rotate(-4deg);
  transform-origin: 50% 50%;
}

.two {
  top: 0px;
  left: 0px;
  z-index: -2;
  transform: rotate(5deg);
  transform-origin: 60% 80%;
}
</style>
